import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import SimpleSelect from './SimpleSelect'
import ReactTooltip from 'react-tooltip'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import moment from 'moment-timezone'

import {faPhone} from '@fortawesome/free-solid-svg-icons'
import { userHasRole } from '../utils/user-helpers'
import { ADD_MESSAGE, SET_CARRIER_QUEUES_SCHEDULE } from '../actions/actionTypes'
import { checkIfWeekend, checkIfHoliday } from '../utils/date-helpers'


const timeOptions = checkIfWeekend() ? 
    [
        { label: 'EOD', value: 'EOD' },
        { label: '13:00', value: '13:00' },
        { label: '13:15', value: '13:15' },
        { label: '13:30', value: '13:30' },
        { label: '13:45', value: '13:45' },
        { label: '14:00', value: '14:00' },
        { label: '14:15', value: '14:15' },
        { label: '14:30', value: '14:30' },
        { label: '14:45', value: '14:45' },
        { label: '15:00', value: '15:00' },
        { label: '15:15', value: '15:15' },
        { label: '15:30', value: '15:30' },
        { label: '15:45', value: '15:45' },
        { label: '16:00', value: '16:00' },
        { label: '16:15', value: '16:15' },
        { label: '16:30', value: '16:30' },
        { label: '16:45', value: '16:45' },
        { label: '17:00', value: '17:00' },
        { label: '17:15', value: '17:15' },
        { label: '17:30', value: '17:30' },
        { label: '17:45', value: '17:45' },
        { label: '18:00', value: '18:00' },
        { label: '18:15', value: '18:15' },
        { label: '18:30', value: '18:30' },
        { label: '18:45', value: '18:45' },
        { label: '19:00', value: '19:00' },
        { label: '19:15', value: '19:15' },
        { label: '19:30', value: '19:30' },
        { label: '19:45', value: '19:45' }
    ]
       :
    [
        { label: 'EOD', value: 'EOD' },
        { label: '17:00', value: '17:00' },
        { label: '17:15', value: '17:15' },
        { label: '17:30', value: '17:30' },
        { label: '17:45', value: '17:45' },
        { label: '18:00', value: '18:00' },
        { label: '18:15', value: '18:15' },
        { label: '18:30', value: '18:30' },
        { label: '18:45', value: '18:45' },
        { label: '19:00', value: '19:00' },
        { label: '19:15', value: '19:15' },
        { label: '19:30', value: '19:30' },
        { label: '19:45', value: '19:45' },
        { label: '20:00', value: '20:00' },
        { label: '20:15', value: '20:15' },
        { label: '20:30', value: '20:30' },
        { label: '20:45', value: '20:45' },
        { label: '21:00', value: '21:00' },
        { label: '21:15', value: '21:15' },
        { label: '21:30', value: '21:30' },
        { label: '21:45', value: '21:45' },
        { label: '22:00', value: '22:00' },
        { label: '22:15', value: '22:15' },
        { label: '22:30', value: '22:30' },
        { label: '22:45', value: '22:45' },
        { label: '23:00', value: '23:00' },
        { label: '23:15', value: '23:15' },
        { label: '23:30', value: '23:30' },
        { label: '23:45', value: '23:45' }
    ]
    
const getQueueName = () => {
    return checkIfWeekend() || checkIfHoliday() ? 'Weekend Holiday' : 'All Carrier'
}

const getQueueEndTime = (schedule) => {
    let rtn
    const dowName = moment().tz("America/Chicago").format('dddd').toLowerCase()

    if (schedule && schedule[dowName] && Array.isArray(schedule[dowName])) {
        rtn = schedule?.[dowName][0]?.to?.includes(':') ? schedule[dowName][0].to : 'EOD'
    } else {
        rtn = 'EOD'
    }
    
    return rtn
}
class RCQueueTimeSelector extends Component {
    async componentDidMount() {
            const queueName = getQueueName()

            await axios({
                method: 'get',
                url: `/api/racoon/call_queues/${queueName}/schedules`
            }).then((result)=>{
                if (result?.status === 200) {
                    this.props.setCarrierQueueSchedules(result?.data)
                } else {
                    throw new Error(JSON.stringify(result))
                }
            }).catch((e)=>{
                console.log('Error fetching carrier queues schedule.  ', e.message)
            })
    }

    onTimeSelect = async (evt) => {
        const {value} = evt.target
        evt.target.blur()

        if (value.includes(':')) {   
            const queueName = getQueueName()
            const dow = moment().tz('America/Chicago').format('dddd').toLowerCase()
            let data = {
                "callQueueNames": [queueName],
                "scheduleMods": {
                }
            }

            data['scheduleMods'][dow] = [
                {
                    "to": value
                }
            ]

            await axios({
                method: 'patch',
                url: '/api/racoon/call_queues/patch_schedules',
                data: data
            }).then((result)=>{
                if (result?.status === 201 && value === result?.data?.monday[0]?.to) {
                    // NOTE: we don't need to set this in the store because we will get a pusher notification
                    this.props.addMessage(`Queues will switch off at ${value}`)
                } else {
                    throw new Error(`value: ${value}.   result.data: ${JSON.stringify(result?.data)}`)
                }
            }).catch((e)=>{
                console.log('Error patching call queues.  ', e.message)
            })
        }
    }

    render() {
        const {authenticatedUser, carrierQueuesSchedule} = this.props
        
        const queueEndTime = getQueueEndTime(carrierQueuesSchedule)
        const backgroundClassName = (authenticatedUser.impersonated_by_user && authenticatedUser.impersonated_by_user.user_id) ? 'nav-bar-impersonate' : 'nav-bar-not-impersonate'
        
        let timeComp

        if (userHasRole(authenticatedUser?.roles || [], 'RC-CAN-SET-QUEUE-TIMES')) {
            timeComp = <SimpleSelect
                customClassName={backgroundClassName}
                values={timeOptions}
                value={{label: queueEndTime, value: queueEndTime }}
                onChange={this.onTimeSelect}
                style={{
                    color: 'white',
                    border: 'none'
                }}
            /> 
        } else {
            timeComp = <div className={{backgroundClassName}} style={{ display: 'inline' }}>{queueEndTime}</div>
        }
            
        const comp = (
            <div>
                <div 
                    data-tip
                    data-for="time-selector"
                    style={{
                        color: 'white',
                        border: 'none',
                        marginRight: '12px',
                        marginTop: '5px'
                    }}
                >
                    <ReactTooltip id="time-selector" place="bottom" type="warning" effect="solid">
                        <span>&nbsp;&nbsp;Carrier Call Queue End Time</span>
                    </ReactTooltip>
                    <FontAwesomeIcon icon={faPhone}/>
                    {timeComp}
                </div>
            </div>
        )

        return comp
    }
}

const mapStateToProps = state => {
    const { authenticatedUser, carrierQueuesSchedule } = state

    return {
        authenticatedUser,
        carrierQueuesSchedule
    }
}
const mapDispatchToProps = dispatch => {
    return {
        addMessage: message => dispatch({ type: ADD_MESSAGE, message: message }),
        setCarrierQueueSchedules: schedule => dispatch({ type: SET_CARRIER_QUEUES_SCHEDULE, schedule})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RCQueueTimeSelector)
